import React, { useContext, useEffect, useState } from "react";
import { SearchContext } from "@context/SearchContext";
import Loader from "@components/Ui/Loader";
import DateSelector from "@components/V3/DateSelector";
import VenueSessionList from "@components/V3/VenueDetails/VenueSessionList";
import "./style.scss";

const VenueSessionSelector = () => {
    const {
        sessionsByVenue,
        isLoadingSessions,
        availableDates,
    } = useContext(SearchContext);
    
    const [selectedDate, setSelectedDate] = useState(null);
    const [filteredSessions, setFilteredSessions] = useState({});

    useEffect(() => {
        if (availableDates.length > 0) {
            const firstDate = availableDates[0];
            setSelectedDate(availableDates[0]);
            handleDateClick(firstDate);
        }
    }, [sessionsByVenue, availableDates, handleDateClick]);

    const handleDateClick = (date) => {
        setSelectedDate(date);
        const filtered = sessionsByVenue[date];
        setFilteredSessions(filtered || {});
    };

    return (
        <>
            {isLoadingSessions ? (
                <Loader isLoading={isLoadingSessions} text="Fetching sessions" />
            ) : (
                <div className="venue-details">
                    <DateSelector
                        uniqueDates={availableDates}
                        handleClickDate={handleDateClick}
                        selectedDate={selectedDate}
                    />
                    <VenueSessionList
                        selectedDate={selectedDate}
                        sessions={filteredSessions}
                    />
                </div>
            )}
        </>
    );
};

export default VenueSessionSelector;
